import {
  MdFormatListBulleted,
  MdExpandLess,
  MdExpandMore,
} from 'react-icons/md'

function CollapsibleListIcon() {
  return (
    <div
      className="h-10 w-10 sm:h-11 sm:w-11 rounded-xl flex items-center justify-center shrink-0"
      style={{ backgroundColor: 'var(--collapsible-icon-bg)' }}
    >
      <MdFormatListBulleted
        className="text-xl"
        style={{ color: 'var(--collapsible-icon-color)' }}
      />
    </div>
  )
}

export interface CollapsibleSectionProps {
  id: string
  title: string
  subtitle: string
  collapsed: boolean
  onToggle: () => void
  children: React.ReactNode
}

export function CollapsibleSection({
  id,
  title,
  subtitle,
  collapsed,
  onToggle,
  children,
}: CollapsibleSectionProps) {
  const panelId = `collapsible-panel-${id}`

  return (
    <div className="rounded-xl border border-[var(--card-divider)] bg-[var(--card-bg)] p-3 sm:p-4 shadow-sm">
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={!collapsed}
        aria-controls={panelId}
        className="w-full flex flex-row items-center justify-between px-2 sm:px-3 py-2.5 text-left bg-transparent hover:opacity-90 transition-opacity"
      >
        <div className="flex items-center gap-3 min-w-0">
          <CollapsibleListIcon />
          <div className="min-w-0 flex flex-col">
            <span className="font-semibold text-[var(--heading-text)] truncate">
              {title}
            </span>
            <span className="text-sm text-[var(--color-primary-400)]">
              {subtitle}
            </span>
          </div>
        </div>
        <span className="shrink-0 ml-2">
          {collapsed ? (
            <MdExpandMore className="text-2xl text-[var(--heading-text)]" />
          ) : (
            <MdExpandLess className="text-2xl text-[var(--heading-text)]" />
          )}
        </span>
      </button>
      {!collapsed && (
        <div
          id={panelId}
          className="mt-2 pt-3 border-t border-[var(--card-divider)]"
        >
          {children}
        </div>
      )}
    </div>
  )
}
